import { type ComponentType } from 'react';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';

/**
 * ComingSoonTab — заглушка placeholder-вкладки раздела «Компания» (AK-350).
 *
 * Не пустая страница: иконка + заголовок + 1-2 предложения о будущем + бейдж
 * «Скоро». Используется вкладками «Роли и доступы» (RBAC v2 / ADR-040),
 * «Справочники» и «Интеграции» до их реализации.
 */
export function ComingSoonTab({
  icon: Icon,
  title,
  description,
}: {
  icon: ComponentType<{ className?: string }>;
  title: string;
  description: string;
}) {
  return (
    <Card className="px-6 py-14 text-center">
      <div className="mx-auto flex max-w-md flex-col items-center">
        <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary text-muted-foreground">
          <Icon className="h-7 w-7" />
        </span>
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <Badge
            variant="secondary"
            className="px-2 py-0 text-xs font-medium"
          >
            Скоро
          </Badge>
        </div>
        <p className="mt-2 text-sm text-muted-foreground">{description}</p>
      </div>
    </Card>
  );
}

export default ComingSoonTab;
